var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value
    ? _c(
        "ItpBadge",
        {
          staticClass: "badge-icon border",
          attrs: {
            title: _vm._.get(_vm.tariffs, _vm.value + ".name", null),
            "no-box-shadow": "",
            variant: "light"
          }
        },
        [
          _c("ItpIcon", { attrs: { name: _vm.$config.tariff.icon } }),
          _vm._v(" "),
          _c("ItpText", { staticClass: "ml-2", attrs: { text: _vm.value } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }